import { ConfigProvider, Drawer } from 'antd';
import styled from 'styled-components';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { Button, Col, Colors, InputSearch, Row, Text } from 'basic-ui-lib';
import useDebounce from 'hooks/useDebounce';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';
import StoreItemMobile from './StoreItemMobile';
import { useNavigate } from 'react-router-dom';
import { IStore } from 'modules/store/interfaces/api';
export interface SelectStoreMobileRef {
  open: () => void;
}

interface SelectStoreMobileProps {}

const SelectStoreMobile = forwardRef<SelectStoreMobileRef, SelectStoreMobileProps>(({}, ref) => {
  const [open, setOpen] = useState(false);
  const { storesList, mutate } = useGetListStores();
  const [selectedStore, setSelectedStore] = useState<IStore | null>(null);
  const navigate = useNavigate();

  const handleSearch = useCallback(
    (searchText: string) => {
      mutate({ page: 1, size: 20, keySearch: searchText || undefined });
    },
    [mutate],
  );

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setSelectedStore(null);
  };

  const { text: searchValue, setText: setSearchValue } = useDebounce({
    value: '',
    timeDebounce: 400,
    onDebounce: handleSearch,
  });

  const handleOk = () => {
    navigate('/screen/create', {
      state: {
        store: selectedStore,
      },
    });
    handleClose();
  };

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <DrawerHeader>
            <Text title_h6 semibold center>
              Select Store
            </Text>
          </DrawerHeader>
        }
        placement='bottom'
        closable={false}
        onClose={handleClose}
        open={open}
        height='90%'
        footer={
          <Row>
            <Button type_cancel lg onClick={handleClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleOk}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <InputSearch value={searchValue} onChange={setSearchValue} placeholder='Search store name/phone' />
        <Col gap={12} flex={1}>
            {storesList?.content.map((store) => (
            <StoreItemMobile
                key={store.storeId}
                item={store}
                selected={selectedStore?.storeId === store.storeId}
                onClick={() => setSelectedStore(store)}
            />
            ))}
        </Col>
      </StyledDrawer>
    </ConfigProvider>
  );
});

SelectStoreMobile.displayName = 'SelectStoreMobile';
export default SelectStoreMobile;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .ant-radio-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
`;

const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
